import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as strings from '../../../base/common/strings.js';
import { ReplaceCommand } from '../commands/replaceCommand.js';
import { CursorColumns, EditOperationResult, isQuote } from './cursorCommon.js';
import { MoveOperations } from './cursorMoveOperations.js';
import { Range } from '../core/range.js';
export var DeleteOperations = /*#__PURE__*/function () {
  function DeleteOperations() {
    _classCallCheck(this, DeleteOperations);
  }

  _createClass(DeleteOperations, null, [{
    key: "deleteRight",
    value: function deleteRight(prevEditOperationType, config, model, selections) {
      var commands = [];
      var shouldPushStackElementBefore = prevEditOperationType !== 3
      /* DeletingRight */
      ;

      for (var i = 0, len = selections.length; i < len; i++) {
        var selection = selections[i];
        var deleteSelection = selection;

        if (deleteSelection.isEmpty()) {
          var position = selection.getPosition();
          var rightOfPosition = MoveOperations.right(config, model, position.lineNumber, position.column);
          deleteSelection = new Range(rightOfPosition.lineNumber, rightOfPosition.column, position.lineNumber, position.column);
        }

        if (deleteSelection.isEmpty()) {
          // Probably at end of file => ignore
          commands[i] = null;
          continue;
        }

        if (deleteSelection.startLineNumber !== deleteSelection.endLineNumber) {
          shouldPushStackElementBefore = true;
        }

        commands[i] = new ReplaceCommand(deleteSelection, '');
      }

      return [shouldPushStackElementBefore, commands];
    }
  }, {
    key: "_isAutoClosingPairDelete",
    value: function _isAutoClosingPairDelete(config, model, selections) {
      if (config.autoClosingBrackets === 'never' && config.autoClosingQuotes === 'never') {
        return false;
      }

      for (var i = 0, len = selections.length; i < len; i++) {
        var selection = selections[i];
        var position = selection.getPosition();

        if (!selection.isEmpty()) {
          return false;
        }

        var lineText = model.getLineContent(position.lineNumber);
        var character = lineText[position.column - 2];
        var autoClosingPairCandidates = config.autoClosingPairsOpen2.get(character);

        if (!autoClosingPairCandidates) {
          return false;
        }

        if (isQuote(character)) {
          if (config.autoClosingQuotes === 'never') {
            return false;
          }
        } else {
          if (config.autoClosingBrackets === 'never') {
            return false;
          }
        }

        var afterCharacter = lineText[position.column - 1];
        var foundAutoClosingPair = false;

        var _iterator = _createForOfIteratorHelper(autoClosingPairCandidates),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var autoClosingPairCandidate = _step.value;

            if (autoClosingPairCandidate.open === character && autoClosingPairCandidate.close === afterCharacter) {
              foundAutoClosingPair = true;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (!foundAutoClosingPair) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "_runAutoClosingPairDelete",
    value: function _runAutoClosingPairDelete(config, model, selections) {
      var commands = [];

      for (var i = 0, len = selections.length; i < len; i++) {
        var position = selections[i].getPosition();
        var deleteSelection = new Range(position.lineNumber, position.column - 1, position.lineNumber, position.column + 1);
        commands[i] = new ReplaceCommand(deleteSelection, '');
      }

      return [true, commands];
    }
  }, {
    key: "deleteLeft",
    value: function deleteLeft(prevEditOperationType, config, model, selections) {
      if (this._isAutoClosingPairDelete(config, model, selections)) {
        return this._runAutoClosingPairDelete(config, model, selections);
      }

      var commands = [];
      var shouldPushStackElementBefore = prevEditOperationType !== 2
      /* DeletingLeft */
      ;

      for (var i = 0, len = selections.length; i < len; i++) {
        var selection = selections[i];
        var deleteSelection = selection;

        if (deleteSelection.isEmpty()) {
          var position = selection.getPosition();

          if (config.useTabStops && position.column > 1) {
            var lineContent = model.getLineContent(position.lineNumber);
            var firstNonWhitespaceIndex = strings.firstNonWhitespaceIndex(lineContent);
            var lastIndentationColumn = firstNonWhitespaceIndex === -1 ?
            /* entire string is whitespace */
            lineContent.length + 1 : firstNonWhitespaceIndex + 1;

            if (position.column <= lastIndentationColumn) {
              var fromVisibleColumn = CursorColumns.visibleColumnFromColumn2(config, model, position);
              var toVisibleColumn = CursorColumns.prevIndentTabStop(fromVisibleColumn, config.indentSize);
              var toColumn = CursorColumns.columnFromVisibleColumn2(config, model, position.lineNumber, toVisibleColumn);
              deleteSelection = new Range(position.lineNumber, toColumn, position.lineNumber, position.column);
            } else {
              deleteSelection = new Range(position.lineNumber, position.column - 1, position.lineNumber, position.column);
            }
          } else {
            var leftOfPosition = MoveOperations.left(config, model, position.lineNumber, position.column);
            deleteSelection = new Range(leftOfPosition.lineNumber, leftOfPosition.column, position.lineNumber, position.column);
          }
        }

        if (deleteSelection.isEmpty()) {
          // Probably at beginning of file => ignore
          commands[i] = null;
          continue;
        }

        if (deleteSelection.startLineNumber !== deleteSelection.endLineNumber) {
          shouldPushStackElementBefore = true;
        }

        commands[i] = new ReplaceCommand(deleteSelection, '');
      }

      return [shouldPushStackElementBefore, commands];
    }
  }, {
    key: "cut",
    value: function cut(config, model, selections) {
      var commands = [];

      for (var i = 0, len = selections.length; i < len; i++) {
        var selection = selections[i];

        if (selection.isEmpty()) {
          if (config.emptySelectionClipboard) {
            // This is a full line cut
            var position = selection.getPosition();
            var startLineNumber = void 0,
                startColumn = void 0,
                endLineNumber = void 0,
                endColumn = void 0;

            if (position.lineNumber < model.getLineCount()) {
              // Cutting a line in the middle of the model
              startLineNumber = position.lineNumber;
              startColumn = 1;
              endLineNumber = position.lineNumber + 1;
              endColumn = 1;
            } else if (position.lineNumber > 1) {
              // Cutting the last line & there are more than 1 lines in the model
              startLineNumber = position.lineNumber - 1;
              startColumn = model.getLineMaxColumn(position.lineNumber - 1);
              endLineNumber = position.lineNumber;
              endColumn = model.getLineMaxColumn(position.lineNumber);
            } else {
              // Cutting the single line that the model contains
              startLineNumber = position.lineNumber;
              startColumn = 1;
              endLineNumber = position.lineNumber;
              endColumn = model.getLineMaxColumn(position.lineNumber);
            }

            var deleteSelection = new Range(startLineNumber, startColumn, endLineNumber, endColumn);

            if (!deleteSelection.isEmpty()) {
              commands[i] = new ReplaceCommand(deleteSelection, '');
            } else {
              commands[i] = null;
            }
          } else {
            // Cannot cut empty selection
            commands[i] = null;
          }
        } else {
          commands[i] = new ReplaceCommand(selection, '');
        }
      }

      return new EditOperationResult(0
      /* Other */
      , commands, {
        shouldPushStackElementBefore: true,
        shouldPushStackElementAfter: true
      });
    }
  }]);

  return DeleteOperations;
}();